import useSWR from 'swr';
import { supabase } from '../../supabase';

export const useServicios = () => {
  const fetcher = async () => {
    // PostgREST suele limitar a 1.000 filas por consulta. Cargar todas las
    // páginas evita que filtros/contadores locales oculten servicios antiguos.
    const pageSize = 1000;
    const services = [];
    let offset = 0;
    let rows;
    do {
      const { data, error } = await supabase
        .from('servicios')
        .select('*')
        .eq('activo', true)
        .order('created_at', { ascending: false })
        .order('id', { ascending: false })
        .range(offset, offset + pageSize - 1);

      if (error) throw error;
      rows = data || [];
      services.push(...rows);
      offset += pageSize;
    } while (rows.length === pageSize);
    return services;
  };

  const { data, error, isLoading, mutate } = useSWR('servicios_activos', fetcher);

  return {
    servicios: data || [],
    isLoading,
    error,
    mutateServicios: mutate
  };
};